// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"40":"68d36527","578":"8598d1e4"}[chunkId] + ".js";
};